import { helpEmail } from '@/data/texas.ts'

export function Footer() {
  return (
    <footer className="mx-auto mt-10 border-t pt-6 text-center text-sm text-slate-600">
      Need assistance?{' '}
      <a
        href={`mailto:${helpEmail}`}
        className="text-primary font-medium hover:underline"
      >
        {helpEmail}
      </a>
      <span className="text-muted-foreground/40 mx-4">•</span>
      <a
        href="https://www.txdmv.gov/site-policies"
        className="text-primary hover:underline"
      >
        Site Policies
      </a>
      <span className="text-muted-foreground/40 mx-2">•</span>
      <a
        href="https://www.txdmv.gov/site-policies/disclaimer"
        className="text-primary hover:underline"
      >
        Disclaimer
      </a>
    </footer>
  )
}
